import { Component, HostListener, OnInit } from "@angular/core";
import { AppService } from "../services/app.service";
import { HttpService } from "../services/http.service";
import { AmplifyService } from "../services/amplify.service";
import { AlertController } from "@ionic/angular";
import { Title } from "@angular/platform-browser";

@Component({
  selector: "app-media",
  templateUrl: "./media.page.html",
  styleUrls: ["./media.page.scss"],
})
export class MediaPage implements OnInit {
  flags: any;
  public isColumnVisible = true;

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.checkScreenSize();
  }

  constructor(
    public app: AppService,
    public http: HttpService,
    public amplify: AmplifyService,
    public alertController: AlertController,
    public title: Title
  ) {
    this.checkScreenSize();
    this.flags = {
      companyMediaList: [],
      userMediaList: [],
      currentMedia: null,
    };

    this.getData();
  }

  getData() {
    this.amplify.storageGet(this.app.sysData.company_id).then((data) => {
      this.flags.companyMediaList = data;
    });

    console.log(this.app.sysData.cognitoUser.username);

    this.amplify.storageGet(null).then((data) => {
      this.flags.userMediaList = data;
    });
  }

  selectMedia(item) {
    this.flags.currentMedia = JSON.parse(JSON.stringify(item));
  }

  checkScreenSize() {
    // This ensures that on larger screens, the visibility is handled automatically,
    // but on smaller screens, the column remains visible unless toggled.
    if (window.innerWidth >= 768) {
      this.isColumnVisible = true; // Always visible on larger screens
    } else {
      // Do not automatically hide on mobile; respect the current toggle state
      // Remove or comment out this line if you want it always visible when reloading the page on mobile:
      // this.isColumnVisible = false;
    }
  }

  toggleColumn() {
    if (window.innerWidth < 768) {
      // Change 768 to your desired breakpoint for smaller screens
      this.isColumnVisible = !this.isColumnVisible;
    }
  }

  deleteFile() {
    var file = this.app.sysData.s3Root + this.flags.currentMedia.key;

    this.amplify.deleteFile(file).then((data) => {
      console.log("delted file response", data);
      this.app.toast("File removed", "success");

      this.getData();
      this.flags.currentMedia = null;
    });
  }

  async presentAlertConfirm(m) {
    const alert = await this.alertController.create({
      header: "Are you sure?",
      message: "This cannot be undone",
      buttons: [
        {
          text: "Cancel",
          role: "cancel",
          cssClass: "secondary",
          handler: (blah) => {
            console.log("Confirm Cancel: blah");
          },
        },
        {
          text: "Okay",
          handler: () => {
            this.deleteFile();
            console.log("Confirm Okay");
          },
        },
      ],
    });

    await alert.present();
  }

  ngOnInit() {
    this.title.setTitle("Uploaded Media");
  }
}
